<template>
<div>
	<search-bar
		:style="{width: searchBarWidth}"
		placeholder="Search..."
		class="search-bar"
		:full-width="true"
		v-model="searchTerms"
		v-on:click="openPanel"
		v-on:submit="searchSubmit"
		v-on:clearSearch="clearSearch">
	</search-bar>

	<div v-show="searchPanelVisible" class="search-panel" :class="{'position-absolute': panelHovers}" ref="panel" tabindex="0" v-on:blur="focusChange">

		<p><small class="text-muted">The search field searches the following fields: <strong>Job Name</strong>, <strong>Job Number</strong>, <strong>Customer PO</strong>, and <strong>Address/City/Postal Code</strong> fields.</small></p>

		<div class="d-flex justify-content-between mb-2">
			<h5>Advanced Filters</h5>
			<i class="fa fa-times icon-button mr-2" v-on:click="closePanel"></i>
		</div>

		<div v-if="fetchingLists">
			<spinner :inline="true"></spinner>
		</div>

		<template v-else>

			<field
				label="Customer"
				col-class="stacked"
				:params="{type:'select',options:$store.customerOptions}"
				v-model="$store.serviceFilteringValues.customer_id"
				v-on:change="filterChange">
			</field>

			<field v-if="$store.serviceFilteringValues.customer_id > 0"
				label="Customer Location"
				col-class="stacked"
				:params="{type:'select',options:customerLocationOptions}"
				v-model="$store.serviceFilteringValues.contact_location_id"
				v-on:change="filterChange">
			</field>

			<field
				label="Assigned To"
				col-class="stacked"
				:params="{type:'select',options:userOptions(false)}"
				v-model="$store.serviceFilteringValues.assigned_to"
				v-on:change="filterChange">
			</field>

			<field
				label="Category"
				col-class="stacked"
				:params="{type:'select',options:categoryOptions}"
				v-model="$store.serviceFilteringValues.category_id"
				v-on:change="filterChange">
			</field>

			<field
				label="Revenue Code"
				col-class="stacked"
				:params="{type:'select',options:revenueCodeOptions}"
				v-model="$store.serviceFilteringValues.revenue_code_id"
				v-on:change="filterChange">
			</field>

			<form-group label="Service # Range" col-class="stacked">

				<div class="d-flex">
					<field
						:params="{type:'text',placeholder:'Range Start'}"
						v-model="$store.serviceFilteringValues.jobRangeStart"
						v-on:change="filterChange">
					</field>
					<field
						:params="{type:'text',placeholder:'Range End'}"
						v-model="$store.serviceFilteringValues.jobRangeEnd"
						v-on:change="filterChange">
					</field>
				</div>

				<small class="text-muted">If Service #s contain alpha-numeric characters this filter may return consistent results</small>

			</form-group>
		</template>
	</div>

</div>
</template>
<script type="text/javascript">

import SearchBar from "@/components/SearchBar";
import Field from "@/components/Field";
import FormGroup from "@/components/FormGroup";
import Spinner from "@/components/Spinner"

export default {
	name: "ServiceSearchBar",
	props: [
		"panelHovers"
	],
	components: {
		SearchBar,
		Field,
		FormGroup,
		Spinner
	},
	data() {
		return {

			searchTerms: false,

			searchPanelVisible: false,
			fetchingLists: false,
			filteringListsFetched: false,

			jobRangeStart: null,
			jobRangeEnd: null,
			customerLocations: []
		}
	},
	computed: {
		searchBarWidth() {
			if (this.searchPanelVisible)
				return "400px"

			return "auto";
		},
		customerLocationOptions() {
			return this.optionify(this.customerLocations.map(location => {
				location.display = location.location_name+" "+location.address
				return location
			}),"display")
		}
	},
	methods: {
		focusChange(e) {
			if (!('relatedTarget' in e && e.relatedTarget))
				this.searchPanelVisible = false
		},
		searchSubmit(terms) {
			this.clearFilters()
			this.searchPanelVisible = false
			this.$emit('searchSubmit', terms)
		},
		clearFilters() {
			this.$store.serviceFilteringValues.customer_id = null
			this.$store.serviceFilteringValues.assigned_to = null
			this.$store.serviceFilteringValues.category_id = null
			this.$store.serviceFilteringValues.revenue_code_id = null
			this.$store.serviceFilteringValues.jobRangeStart = null
			this.$store.serviceFilteringValues.jobRangeEnd = null
		},
		filterChange() {
			let vm = this
			this.searchTerms = null
			this.$refs.panel.focus()
			this.$emit('filterChange')

			this.$nextTick(() => {
				if (vm.$store.serviceFilteringValues.customer_id > 0)
					vm.fetchCustomerLocations()
			})
		},
		clearSearch() {
			this.searchTerms = null
			this.clearFilters()
			this.$emit('clearSearch')
		},
		openPanel() {

			if (this.$store.serviceFilterArchiveValue == 'mine') 
				this.$store.serviceFilterArchiveValue = 'all'

			this.searchPanelVisible = true

			if (!this.filteringListsFetched)
				this.fetchFilteringLists()
			//}
		},
		closePanel() {
			this.searchPanelVisible = false
		},
		fetchCustomerLocations() {
			let vm = this 

			let params = {
				filters: [
					["contact_id",vm.$store.serviceFilteringValues.customer_id]
				]
			}

			this.getJSON("ContactLocation/get",params).then(response => {
				if (response.success) {
					vm.customerLocations = response.data
				}
			})
		},
		fetchFilteringLists() {
			let vm = this

			let promises = [
				this.fetchUsers(null,null,["id",'slug',"first_name","last_name"]),
				this.fetchCustomers(),
				this.fetchRevenueCodes()
			]

			this.fetchingLists = true

			Promise.all(promises).then(responses => {
				vm.filteringListsFetched = true
				vm.fetchingLists = false
			})
		},
	}
}
</script>


<style type="text/css" scoped>

.search-panel {
	width: 400px;
	background-color: var(--background-light);
	padding: 8px;
	margin-top: 4px;
	z-index: 10;
	border: var(--background-menus) solid 1px;
}

@media (max-width: 600px) {

	.search-panel {
		width: 100%;
		margin: 0;
	}

}
</style>